<!-- 泊链方式第三方车场接入指南 -->
<template>
    <div class="content">
        <ul>
            <li>
                <h3 class="title">接口对接流程</h3>
                <h4>写在前面的话</h4>
                <br/>
                <div>
                如果还在跑流程，验证接口调用是否正常等问题，使用测试环境：车辆进场http://openydt.yidianting.xin/Api/mockInOut（mockType=0），
                查费http://openydt.yidianting.xin/Api/getParkFee，缴费（同步账单）http://openydt.yidianting.xin/Api/payParkFee，
                缴费后车辆行驶到道闸处就可以自动开闸离场，此时应调用http://openydt.yidianting.xin/Api/mockInOut（mockType=1），完成模拟出场操作，
                车辆出场后，查费操作将查不到在场车辆记录。
                </div>
                <br/>
                <div>
                如果想在现场真实环境验证产品功能，请提前联系车场管理方沟通确认，并使用生产环境：进场请使用测试车辆驶入被测试车场，
                查费http://openydt.yidianting.xin/Api/getParkFee，
                缴费（同步账单）http://openydt.yidianting.xin/Api/payParkFee，
                缴费后，车辆行驶到出口道闸处就可以自动开闸离场。
                </div>
                <br/>
                <h4>智慧停车支付（通用支付）</h4>
                <div class="ShaShiDi3">
                    <img src="/static/img/一点停支付（通用支付）流程.png"/>
                </div>
                <h4>无感支付</h4>
                <br/>
                <div class="ShaShiDi">
                    <img src="/static/img/无感支付业务流程.png"/>
                </div>
                <h4>车位预订</h4>
                <br/>
                <div class="ShaShiDi">
                    <img src="/static/img/车位预订.png"/>
                </div>
                <h4>城市运营积分</h4>
                <br/>
                <div class="ShaShiDi">
                    <img src="/static/img/城市运营积分.png"/>
                </div>

                <h4>第三方会员与智慧停车微信互通（免密登录智慧停车微信、积分、商家券使用）</h4>
                <br/>
                <div class="ShaShiDi2">
                    <img src="/static/img/第三方会员与一点停互通（免密登录一点停、积分、商家券使用）.svg"/>
                </div>

                <h4>第三方扫通道二维码自助进出场</h4>
                <br/>
                <div class="ShaShiDi">
                    <img src="/static/img/第三方通道二维码流程.png"/>
                </div>
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            respTable: [
                { info1: 'status', info2: '是', info3: 'int', info4: '状态码',info5:'1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码',info5:'只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误'},
                { info1: 'message', info2: '是', info3: 'String', info4: '结果描述' },
                { info1: 'data', info2: '是', info3: 'JSONObject', info4: '返回数据' }
            ],
            othersData: [],
            explainWidth: 200,
        }
    },
}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        padding: 0px 0 20px 0; // font-family: HiraginoSansGB-W3;
        font-size: 18px;
        color: #111B29;
        letter-spacing: 0
    }
    a {
        font-size: 13px;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
    .retract {
        padding-left: 15px;
    }
    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}

.ShaShiDi{
width:800px;
height:800px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi img{
    width:100%;
    height:auto;
}

.ShaShiDi2{
width:800px;
height:1200px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi2 img{
    width:100%;
    height:auto;
}

.ShaShiDi3{
width:800px;
height:900px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi3 img{
    width:100%;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/procedureData.vue